import {bounce, center, important, inputPlaceholder, lighten, rem, size} from '-/styles/utils';

const styles = theme => ({
    control: {
        textAlign: 'center'
    },
    description: {
        paddingTop: rem(30)
    },
    icon: {
        display: 'table',
        position: 'relative',
        margin: '0 auto',
        fontSize: '4em'
    },
    headerImg: {
        width: 64,
        height: 54
    },
    errorText: {
        lineHeight: rem(27),
        opacity: 0.9,
        textAlign: 'center'
    },
    text: {
        margin: rem(25),
        '& h3': {
            margin: 0,
            fontSize: rem(20),
            fontWeight: 'bold',
            lineHeight: rem(27),
            textTransform: 'capitalize',
            textAlign: 'center',
            opacity: .9,
            color: theme.colors.primary
        }
    },
    verifyIcon: {
        ...size('30px', '30px'),
        position: 'absolute',
        bottom: rem(0),
        right: rem(0),
        borderRadius: '50%',
        backgroundColor: theme.colors.primary,
        ...bounce(),
        '&::before, &:before': {
            ...center('both'),
            content: '"\\f00c"',
            display: 'block',
            fontFamily: 'FontAwesome',
            fontSize: '75%',
            fontWeight: 'normal',
            lineHeight: rem(24),
            color: 'white'
        }
    },
    verifyIconSuccess: {
        '&::before, &:before': {
            fontSize: 18,
            content: '"\\f00c"'
        }
    },
    verifyIconFail: {
        '&::before, &:before': {
            content: '"\\f12a"'
        }
    },
    accountInput: {
        '& input': {
            padding: 0,
            margin: '0 auto',
            border: 'none',
            fontFamily: theme.fontFamily,
            fontSize: rem(31),
            fontWeight: 'normal',
            lineHeight: rem(44),
            letterSpacing: rem(3),
            color: '#aaa',
            textAlign: 'center',
            backgroundColor: 'transparent',
            ...inputPlaceholder({
                color: lighten('#aaa', .2),
                fontSize: rem(31)
            }),
            '&:active, &:focus, &:hover': {
                outline: 0,
                border: 'none',
                boxShadow: 'none'
            }
        }
    }
});

export default styles;